import personTypes from './person/types';
import personalInformationTypes from './personal-information/types';
import customerNotificationTypes from './customer-notification/types';
import customerDocumentsTypes from './customer-documents/types';

export default {
  ...personTypes,
  ...personalInformationTypes,
  ...customerNotificationTypes,
  ...customerDocumentsTypes,
};
